import { BatchTracingConf } from './conf/batch-tracing-conf'

export class TracedMaterialUpdate {
  constructor(
    public itemId: string,
    public workCenterId: string,
    public materialPath: string,
    public conf: BatchTracingConf
  ) {}
}
